import { getFetch } from '../fetch';
import { apiConfig } from '../config';

export function getQuiz(uuid: string): Promise<void> {
    const { apiGetQuiz } = apiConfig.getStaticUrls();

    return getFetch(`${apiGetQuiz}${uuid}/`);
}

